import PropTypes from 'prop-types';
import { AlertCircle, CheckCircle2, AlertTriangle, X, Info } from 'lucide-react';

export const Toast = ({ notification, onClose }) => {
  if (!notification) return null;
  const isNoStock = notification.type === 'nostock' || 
                    (typeof notification.message === 'string' && 
                     (notification.message.toLowerCase().includes('out of stock') || notification.message.toLowerCase().includes('no stock')));
  const isSuccess = notification.type === 'success';
  const isWarning = notification.type === 'warning' && !isNoStock;
  const isInfo = notification.type === 'info';
  
  let borderColor = 'border-red-100';
  let bgColor = 'bg-red-500';
  let iconBg = 'bg-red-50 text-red-500';
  let title = notification.title || 'Error';
  let Icon = AlertCircle;

  if (isNoStock) {
    borderColor = 'border-red-100';
    bgColor = 'bg-red-500';
    iconBg = 'bg-red-50 text-red-500';
    title = 'WARNING';
    Icon = AlertTriangle;
  } else if (isSuccess) {
    borderColor = 'border-emerald-100';
    bgColor = 'bg-emerald-500';
    iconBg = 'bg-emerald-50 text-emerald-600';
    title = 'Success';
    Icon = CheckCircle2;
  } else if (isWarning) {
    borderColor = 'border-amber-100';
    bgColor = 'bg-amber-500';
    iconBg = 'bg-amber-50 text-amber-500';
    title = 'Warning';
    Icon = AlertTriangle;
  } else if (isInfo) {
    borderColor = 'border-blue-100';
    bgColor = 'bg-blue-500';
    iconBg = 'bg-blue-50 text-blue-500';
    title = 'Info';
    Icon = Info;
  }

  return (
    <div
      className={`fixed top-5 right-5 z-[999999] w-[min(320px,calc(100vw-28px))] overflow-hidden rounded-md border bg-white shadow-[0_14px_36px_rgba(15,23,42,0.14)] animate-toast-in ${borderColor}`}
    >
      <div className={`absolute left-0 top-0 h-full w-1 ${bgColor}`} />
      <div className="flex items-start gap-2.5 px-3.5 py-2.5 pl-4">
        <div className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full ${iconBg}`}>
          <Icon size={13} />
        </div>
        <div className="min-w-0 flex-1 pr-1">
          <div className="text-[11px] font-bold uppercase tracking-widest text-[#0d0d0d]">
            {title}
          </div>
          <div className="mt-0.5 text-[13px] font-medium leading-snug text-gray-700">
            {notification.message}
          </div>
        </div>
        <button
          type="button"
          onClick={onClose}
          className="rounded-sm p-0.5 text-gray-300 transition-colors hover:bg-gray-50 hover:text-gray-700 outline-none"
          aria-label="Dismiss notification"
        >
          <X size={12} />
        </button>
      </div>
      <div className="h-[2px] bg-gray-100">
        <div className={`h-full animate-toast-timer ${bgColor}`} />
      </div>
    </div>
  );
};

Toast.propTypes = {
  notification: PropTypes.shape({
    message: PropTypes.string,
    type: PropTypes.string,
  }),
  onClose: PropTypes.func.isRequired,
};
